import { FC } from 'react'
import CourseFormModal from '@modals/CourseFormModal'
import { MyCourseDetailed } from '@models/myCourse'

type Props = {
  handleCloseModal: () => void
  isEdit?: boolean
  course?: MyCourseDetailed
}

type InternalCourseFormModalComponent = FC<Props> & { modalWidth?: string }

const InternalCourseFormModal: InternalCourseFormModalComponent = (props) => {
  return <CourseFormModal {...props} internalCourseMode />
}

InternalCourseFormModal.modalWidth = CourseFormModal.modalWidth

export default InternalCourseFormModal
